import { isTestEnv } from '@towns-protocol/dlog';
// eslint-disable-next-line no-restricted-imports
import { QueryClient, useMutation as useMutationBase, useQueryClient, useQuery as useBaseQuery, useQueries, QueryClientProvider, } from '@tanstack/react-query';
import { useMemo } from 'react';
const defaultStaleTime = 1_000 * 15;
const staleTime24Hours = 1000 * 60 * 60 * 24;
// queryClient is imported in non React contexts (where we would normally useQueryClient)
// test query client should be the same instance as the queryClient used in lib code, hence we export it here
let config;
if (isTestEnv()) {
    config = {
        defaultOptions: {
            queries: {
                retry: false,
            },
        },
    };
}
const queryClient = new QueryClient(config);
// wrapping useQuery to set default options
// why not just set default options in the queryClient? Mostly to avoid potential confusion.
// lib uses react query for fetching blockchain data. the below is a good default for that use case.
// Consumers that use lib might use react-query too, but might not have the same use case.
// If the consumer doesn't wrap their own code in a separate queryClient, they will inherit the lib's queryClient and its default options.
// So lib code can use this hook instead, to set the default options for its own use cases.
function useQuery(key, queryFn, options) {
    const { data, error, isError, isPending, isLoading, isLoadingError, isRefetchError, isSuccess, status, } = useBaseQuery({
        queryKey: key,
        queryFn,
        staleTime: defaultStaleTime,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        ...(options ?? {}),
    });
    // fucking base query returns a new object every fucking time what fucking amatures
    return useMemo(() => ({
        data,
        error,
        isError,
        isPending,
        isLoading,
        isLoadingError,
        isRefetchError,
        isSuccess,
        status,
    }), [
        data,
        error,
        isError,
        isPending,
        isLoading,
        isLoadingError,
        isRefetchError,
        isSuccess,
        status,
    ]);
}
function useMutation(options, queryClient) {
    return useMutationBase(options, queryClient);
}
// [re]exporting from here so other files can import from this file for all their needs
export { useQuery, queryClient, useMutation, useQueries, useQueryClient, QueryClientProvider, defaultStaleTime, staleTime24Hours, };
//# sourceMappingURL=queryClient.js.map